import { createSelector } from '@reduxjs/toolkit';
import { Comment } from 'api/conversations';
import { RootState } from 'data';
import { ConversationContext, ConversationStore } from './types';

export const getComment = (context: ConversationContext, commentId: number) =>
  createSelector(
    (state: RootState) =>
      state.conversation[`${context.type}-${context.id}`].allComments,
    (comments: Comment[]): Comment | undefined =>
      comments.find((comment) => comment.commentId === commentId),
  );

export const selectConversation =
  (context: ConversationContext) =>
  ({ conversation }: RootState): ValueOf<ConversationStore> =>
    conversation[`${context.type}-${context.id}`];
